import { BaseAccountController, TAccountControllerConfig } from './BaseAccountController'
import { EVMAccountController } from './EvmAccountController'
import { SolAccountController } from './SolAccountController'
import { SuiAccountController } from './SuiAccountController'
import { BuyBackItem, LiquidationAsset } from '../../coinLiquidation/types'

export class AccountController {
  private static instance: AccountController
  public static self() {
    if (!this.instance) {
      this.instance = new AccountController()
    }
    return this.instance
  }

  private _currentAddress: string
  private _type: 'EVM' | 'SOL' | 'SUI'
  private _controller: BaseAccountController

  get type() {
    return this._type
  }

  onChangeAccount(_address: string, type: 'EVM' | 'SOL' | 'SUI', config: TAccountControllerConfig) {
    this._currentAddress = _address
    this._type = type
    switch (type) {
      case 'EVM':
        this._controller = new EVMAccountController(_address, config)
        break
      case 'SOL':
        this._controller = new SolAccountController(_address, config)
        break
      case 'SUI':
        this._controller = new SuiAccountController(_address, config)
        break

      default:
        break
    }
  }

  updateConfig(config: TAccountControllerConfig) {
    if (this._controller) {
      this._controller.updateConfig(config)
    }
  }
  fetchTokens(callback: (progress: any) => void) {
    return this._controller.loadAccountTokens(this._currentAddress, callback)
  }

  sellAll(tokens: Array<LiquidationAsset>, callback: (info: any) => void) {
    return this._controller.sellAll(tokens, callback)
  }

  getCache() {
    return this._controller.loadCache()
  }

  buyBackItem(item: BuyBackItem, sscb: (swapHash: string) => void, errcb: () => void) {
    return this._controller.buyBackItem(item, sscb, errcb)
  }
}
